import { notification } from 'antd'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { extractApiErrorMessage } from '../../helpers/apiErrorMessage'
import { getAccount, updateAvatar, updateDisplayName, updatePassword } from './accountApi'

export const ACCOUNT_QUERY_KEY = ['account', 'current-user']

export const useAccount = (enabled: boolean) => {
  return useQuery({
    queryKey: ACCOUNT_QUERY_KEY,
    queryFn: getAccount,
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false
  })
}

export const useUpdateDisplayName = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateDisplayName,
    onSettled: () => {
      queryClient.invalidateQueries(ACCOUNT_QUERY_KEY)
    }
  })
}

export const useUpdatePassword = () => {
  return useMutation(updatePassword)
}

export const useUpdateAvatar = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateAvatar,
    onError: (error) => {
      notification.error({ message: extractApiErrorMessage(error, 'There was an error saving your avatar') })
    },
    onSettled: () => {
      queryClient.invalidateQueries(ACCOUNT_QUERY_KEY)
    }
  })
}
